import Swal from "sweetalert2";

// Helpers
import { checkExtension, isStage } from "src/helpers";

// Services
import { MediaManagerInstance } from "src/services/media-manager";
import { createWsClient } from "src/services/ws";

// Actions
import { getPaDetails } from "src/store/auth/actions";
import { paDetailsLoaded, setAppAsLoaded } from "src/store/auth/reducer";
import { setPaNumber, setQueues } from "src/store/config/reducer";
import { doGetPauseTypesRequest, doPausePaRequest, doUnpausePaRequest } from "src/store/context/actions";
import { pauseTypesLoaded, togglePause } from "src/store/context/reducer";
import { ReturnData } from "src/types";

export default async function userRegistration(
  references: {
    waitingTransferTimer: any;
    currentPauseStatus: any;
  },
  store: {
    appWasLoaded: any;
    paused: any;
    sip: any;
    queues: any;
    inputDeviceId: any;
    cameraDeviceId: any;
    dispatch: any;
  },

  methods: {
    pausePa: Function;
  },
): Promise<ReturnData> {
  // Redux Access

  const { appWasLoaded, paused, sip, queues, inputDeviceId, cameraDeviceId, dispatch } = store;

  // Check Extension
  const extEnabled = await checkExtension();

  // Ws Declare
  let ws: Awaited<ReturnType<typeof createWsClient>> | null;

  // Get Pa Number
  async function getPANumber() {
    const { value: paNumber } = await Swal.fire({
      title: "Informe abaixo o número do seu ramal",
      input: "text",
      inputLabel: "Numero do Ramal",
      showCancelButton: false,
      showCloseButton: false,
      allowOutsideClick: false,
      confirmButtonText: "Entrar",
      customClass: {
        title: "dark:text-neutral-gray-50!",
        popup: "dark:bg-neutral-gray-900",
        actions: "dark:bg-neutral-gray-800!",
        inputLabel: "dark:text-neutral-gray-50!",
        input: "dark:text-neutral-gray-50! dark:bg-neutral-gray-800 dark:border-neutral-gray-800",
        confirmButton: "dark:bg-primary-blue-400 dark:text-white",
      },
      inputValidator: (value) => {
        if (!value || isNaN(Number(value))) {
          return "Digite apenas números!";
        }
      },
    });

    dispatch(setPaNumber(paNumber));
    return paNumber;
  }

  // Validade extension
  if (!extEnabled && !isStage) {
    await Swal.fire({
      title: "Extensão não instalada!",
      html: `Não foi detectada a extensão ICOM, para prosseguir favor instalar clicando <a href="https://chromewebstore.google.com/detail/okafgffdfbfkfhpgdalfammhnkbkabon/" target="_blank" style="color: blue;">aqui.</a> 
          Após instalar clique no botão recarregar para prosseguir.`,
      confirmButtonText: "Recarregar página",
    });

    if (!import.meta.env.DEV) window.location.reload();
  }

  // Get details from PA
  const [paDetailsRequest, getPauseTypesRequest] = await Promise.all([getPaDetails(), doGetPauseTypesRequest()]);

  // Ramal?
  let ramal = Number(sip.paNumber);

  if (!sip.paNumber) ramal = await getPANumber();

  // If success
  if (paDetailsRequest.success) {
    let paData = { ...paDetailsRequest.data };
    let _queues = queues;

    // Filter queues by morga
    if (!appWasLoaded) {
      _queues = paDetailsRequest.data.morga ? paDetailsRequest.data.fila : paDetailsRequest.data.fila.filter((q: string) => q.toLowerCase().indexOf("abr") === -1);

      dispatch(setQueues(_queues));
    }

    // Save PA Data
    dispatch(
      paDetailsLoaded({
        ...paData,
      }),
    );

    dispatch(pauseTypesLoaded([...getPauseTypesRequest.data]));

    // Set medias
    const createMediaResponse = await MediaManagerInstance.createMediaStream({
      inputDeviceId,
      cameraDeviceId,
    });

    if (!createMediaResponse.success) {
      // alert(createMediaResponse.message);

      return {
        success: false,
        message: `Falha ao obter dispositivos de mídia, ${createMediaResponse.message}`,
      };
    }

    // Init Websocket
    ws = await createWsClient({
      queuesArray: _queues, //["ABR-texto", "abr", "icom"], //
      paName: paDetailsRequest.data.nome,
      paRamal: ramal,
      paId: paDetailsRequest.data.id,
      hasMorgaCertificate: paDetailsRequest.data.morga,
    });

    if (!appWasLoaded) {
      dispatch(setAppAsLoaded());

      // Register Livre transferencia
      const { success, message } = await doPausePaRequest("12");

      // Update Queue
      if (success) {
        ws?.sendMessage({
          type: "PA_SET_STATUS_AVAILABLE",
          data: {
            isWaitingTransfer: true,
          },
        });

        // Set timer
        references.waitingTransferTimer.current = setTimeout(async () => {
          const { success, message } = await doUnpausePaRequest();

          dispatch(togglePause(false));

          // Update Queue
          ws?.sendMessage({
            type: "PA_SET_STATUS_AVAILABLE",
            data: {
              isWaitingTransfer: false,
            },
          });

          // Clear current pause status
          references.currentPauseStatus.current = null;
        }, 60 * 1000);
      }
    } else if (paused) {
      await methods.pausePa(paused);
    } else {
      ws?.sendMessage({
        type: "PA_SET_STATUS_AVAILABLE",
        data: {
          isWaitingTransfer: false,
        },
      });
    }

    return {
      success: true,
      data: {
        ws,
      },
    };
  }

  return {
    success: false,
    message: `Falha ao carregar detalhes da PA, verifique sua conexão com a internet. ${paDetailsRequest.message}`,
  };
}
